module.exports = __webpack_public_path__ + "img/7.3c9fb12c.jpg";